export default {
  rooms: {
    label: 'Sélectionnez les pièces concernées par le déménagement :',
  },
  newRoom: {
    placeholder: 'Autre pièce',
    add: 'Ajouter',
  },
};
